"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var sdk_1 = require("@flatfile/sdk");
var react_1 = __importStar(require("react"));
var FlatfileButton = function (_a) {
    var open = _a.open, theme = _a.theme, token = _a.token, mountUrl = _a.mountUrl, apiUrl = _a.apiUrl, autoContinue = _a.autoContinue, customFields = _a.customFields, chunkSize = _a.chunkSize, mountOn = _a.mountOn, embedId = _a.embedId, org = _a.org, user = _a.user, onInit = _a.onInit, onData = _a.onData, onComplete = _a.onComplete, onError = _a.onError, buttonProps = _a.buttonProps, render = _a.render, children = _a.children;
    var handleLaunch = react_1.useCallback(function () {
        return sdk_1.Flatfile.requestDataFromUser({
            open: open,
            theme: theme,
            token: token,
            embedId: embedId,
            org: org,
            user: user,
            mountUrl: mountUrl,
            apiUrl: apiUrl,
            autoContinue: autoContinue,
            customFields: customFields,
            chunkSize: chunkSize,
            mountOn: mountOn,
            onInit: onInit,
            onData: onData,
            onComplete: onComplete,
            onError: onError,
        });
    }, [token]);
    return render ? (render({ launch: handleLaunch })) : (react_1.default.createElement("button", __assign({}, buttonProps, { onClick: function () { return handleLaunch(); } }), children));
};
exports.default = FlatfileButton;
//# sourceMappingURL=FlatfileButton.js.map